export default __webpack_public_path__ + "assets/images/1027a892d59a1f6becae7adaf4022354.png";